import loginService from '@/api/auth.service'
import candidateService from '@/api/candidate.service'

const actions = {
  getCandidateInfo(context) {
    return new Promise((resolve, reject) => {
      candidateService
        .getCandidateInfo(context)
        .then(response => {
          context.commit('candidateInfo', response)

          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  editNameInfo(context, data) {
    return new Promise((resolve, reject) => {
      loginService
        .postEditName(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  editEmailInfo(context, data) {
    return new Promise((resolve, reject) => {
      loginService
        .postCandEditEmail(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  editPasswordInfo(context, data) {
    return new Promise((resolve, reject) => {
      loginService
        .postEditPassword(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}
export default actions
